import { getBackendUrl } from "@Utils";
import UserNameTagComponent from "@CubeComponents/html/UserNameTagComponent";
import IconComponent from "@CubeComponents/icons";
import useUserCardData from "./useUserCardData";

function UserCard({
  field,
  id,
  removeUserFromList = () => {},
  fieldIndex = 0,
  sectionIndex = 0,
  section = {},
  source = "",
  tableRowIndex = 0,
  showAnswersOnly,
  handleCustomFieldData,
  extraParams,
}: any) {
  const { userData } = useUserCardData({ id });
  const dataToDisplay = field.dataToDisplay;

  return (
    <div className="rounded-md border-solid bg-slate-50 border-2 h-30 p-2 border-button_light flex flex-col gap-2">
      <div className="flex gap-2 items-center justify-around">
        <span>
          <UserNameTagComponent showAvatarOnly id={id} size="LSM" isCircle />
        </span>
        <span>{userData.fullName}</span>
        {!showAnswersOnly && (
          <span
            className="flex items-center"
            onClick={() =>
              removeUserFromList({
                fieldIndex,
                sectionIndex,
                user: userData,
                section,
                eachField: field,
                source,
                tableRowIndex,
                handleCustomFieldData,
                extraParams,
              })
            }
          >
            <IconComponent className="cursor-pointer" name="cross" width="1rem" height="1rem" />
          </span>
        )}
      </div>
      {dataToDisplay.includes("email") && <div>{userData.email}</div>}
      {dataToDisplay.includes("contactNo") && <div>{userData.contactNo}</div>}
      {dataToDisplay.includes("designation") && <div>{userData.designation}</div>}
      {dataToDisplay.includes("org") && <div>{userData.organisationName}</div>}
      {dataToDisplay.includes("location") && <div>{userData.userLocation}</div>}
      {dataToDisplay.includes("userId") && <div>{userData.userId ?? ""}</div>}
      {userData.signature && dataToDisplay.includes("signature") && (
        <div>
          <img className="w-16 h-16" src={`${getBackendUrl()}/fileSystemServer/getSignDocs/${userData.signature}`} />
        </div>
      )}
    </div>
  );
}
export default UserCard;
